export default "__VITE_ASSET__DKlfSqUL__"